import api from "@/lib/api";

const urlBase64ToUint8Array = (base64String) => {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};

export const pushSupported = () =>
  typeof window !== "undefined" && "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

/** iOS : le push Web n'est disponible que si l'app est installée sur l'écran d'accueil (iOS 16.4+). */
export const isIosNotInstalled = () => {
  const ua = window.navigator.userAgent;
  const ios = /iPhone|iPad|iPod/i.test(ua);
  const standalone = window.navigator.standalone === true || window.matchMedia("(display-mode: standalone)").matches;
  return ios && !standalone;
};

export const registerSW = async () => {
  if (!("serviceWorker" in navigator)) return null;
  return navigator.serviceWorker.register("/sw.js", { scope: "/" });
};

export const getPushSubscription = async () => {
  if (!pushSupported()) return null;
  const reg = await navigator.serviceWorker.getRegistration("/");
  if (!reg) return null;
  return reg.pushManager.getSubscription();
};

/** Active les notifications push : permission -> abonnement navigateur -> enregistrement serveur. */
export const enablePush = async () => {
  if (!pushSupported()) throw new Error("Ce navigateur ne prend pas en charge les notifications push");
  const { data: cfg } = await api.get("/push/config");
  if (!cfg.enabled || !cfg.public_key) throw new Error("Notifications push non configurées");
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("Permission refusée");
  const reg = (await navigator.serviceWorker.getRegistration("/")) || (await registerSW());
  await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: urlBase64ToUint8Array(cfg.public_key) });
  }
  await api.post("/push/subscribe", { subscription: sub.toJSON(), user_agent: navigator.userAgent });
  return true;
};

export const disablePush = async () => {
  const sub = await getPushSubscription();
  if (sub) {
    try { await api.delete("/push/subscribe", { data: { subscription: sub.toJSON() } }); } catch (e) {}
    await sub.unsubscribe();
  }
  return true;
};
